// extracted by mini-css-extract-plugin
export default {"tools":"Tools_tools__fWyz-","dark":"Tools_dark__Wsdpk","tools-title":"Tools_tools-title__F3177","tools-wrapper":"Tools_tools-wrapper__u+2Th","tool":"Tools_tool__dvmX6"};